import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const CTA = () => {
  return (
    <section className="py-24 bg-[rgb(17,17,19)] relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[rgba(0,250,99,0.05)] via-transparent to-[rgba(127,74,142,0.05)]" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="bg-[rgb(26,28,30)] border border-[rgba(255,255,255,0.1)] rounded-3xl p-12 md:p-16 text-center relative overflow-hidden">
            {/* Top Accent Border */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[rgb(0,250,99)] to-transparent" />

            {/* Content */}
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Let's Talk About Your Brand
            </h2>
            <p className="text-xl text-[rgb(218,218,218)] mb-8 max-w-2xl mx-auto">
              Not sure where to start, or what will work best for your brand? Share a few details with us, and we'll help you understand the right approach.
            </p>

            {/* Features */}
            <div className="flex flex-wrap justify-center gap-4 mb-10 text-sm">
              {[
                'Strategy & Content',
                'Platform Guidance',
                'Timeline Planning',
                'Budget Optimization'
              ].map((feature, index) => (
                <div
                  key={index}
                  className="px-4 py-2 bg-[rgba(0,250,99,0.1)] border border-[rgba(0,250,99,0.3)] rounded-full text-[rgb(0,250,99)]"
                >
                  {feature}
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <Link
              to="/contact"
              className="group inline-flex items-center space-x-2 px-8 py-4 bg-[rgb(0,250,99)] text-[rgb(17,17,19)] rounded-xl font-semibold text-lg hover:bg-[rgb(0,220,87)] transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_8px_25px_rgba(0,250,99,0.3)]"
            >
              <span>Request a Free Consultation</span>
              <ArrowRight
                size={20}
                className="group-hover:translate-x-1 transition-transform"
              />
            </Link>

            {/* Trust Badge */}
            <p className="text-[rgb(161,161,170)] text-sm mt-8">
              Join 50+ healthcare brands growing with clarity and measurable results
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
